import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import { DebitNoteOperationResult } from "../entities/DebitNoteEntity";

/**
 * Reject Debit Note Use Case
 * Rejects a debit note
 */
export class RejectDebitNoteUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(debitNoteId: number): Promise<DebitNoteOperationResult> {
    return await this.repository.rejectDebitNote(debitNoteId);
  }
}
